import { useSelector } from 'react-redux';
import { ChargePoint, UserOrganisation } from '../../../../../../app/ApiGen';
import { fullStateSelector } from '../../../../../../store/root';
import { Normalised } from '../../../../../../utils/request';

const MenuItemLabels = [
  'Overview',
  'Sessions',
  'Load management',
  'Logs',
  'Firmware',
  'Advanced',
  'Settings',
  'Diagnostics',
  'LLM diagnostics',
  'Charging configuration',
  'Connection configuration',
] as const;

export type MenuItemLabel = (typeof MenuItemLabels)[number];

type MenuItemMeta = {
  text: MenuItemLabel;
  path: string;
  shouldRender: boolean;
};

type MenuItemDefinitionParams = {
  organisation: UserOrganisation;
  chargePoint: Normalised<ChargePoint>;
};

export function useMenuItemsFactory(params: MenuItemDefinitionParams): MenuItemMeta[] {
  const { organisation, chargePoint } = params;
  const { isAdmin, isEvnexAdmin, isFleetOperator } = useSelector(fullStateSelector);

  return [
    {
      text: 'Overview',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/overview`,
      shouldRender: true,
    },
    {
      text: 'Sessions',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/sessions`,
      shouldRender: true,
    },
    {
      text: 'Load management',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/load-management`,
      shouldRender: true,
    },
    {
      text: 'Logs',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/logs`,
      shouldRender: isEvnexAdmin || isAdmin,
    },
    {
      text: 'Firmware',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/firmware`,
      shouldRender: isEvnexAdmin || isAdmin,
    },
    {
      text: 'Advanced',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/advanced`,
      shouldRender: isEvnexAdmin || isAdmin,
    },
    {
      text: 'Settings',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/settings`,
      shouldRender: true,
    },
    {
      text: 'Diagnostics',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/diagnostics`,
      shouldRender: isEvnexAdmin,
    },
    {
      text: 'LLM diagnostics',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/llm-diagnostics`,
      shouldRender: isEvnexAdmin,
    },
    {
      text: 'Charging configuration',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/charging-configuration`,
      shouldRender: isEvnexAdmin || isAdmin || isFleetOperator,
    },
    {
      text: 'Connection configuration',
      path: `/organisations/${organisation.slug}/charge-points/${chargePoint.id}/connection-configuration`,
      shouldRender: isEvnexAdmin,
    },
  ];
}
